/* eslint-disable no-console */
/* eslint-disable no-underscore-dangle */
/* eslint-disable no-unused-expressions */
/* eslint-disable no-inner-declarations */
import { put, takeLatest, select, call } from 'redux-saga/effects';
import { uniq, takeRight } from 'lodash';
import qz from 'qz-tray';
import { delay } from 'redux-saga';
import moment from 'moment';
import { setNotification } from 'utils';
import * as LogisticActions from '../actions/logisticActions';
import * as LogisticApis from '../api/logisticApi';
import * as LogisticTypes from '../types/logisticTypes';
import * as Macros from './macros';

const getLayout = state => state.layout;
const getLogistic = state => state.logistic;
const getForm = state => state.form;

// L O A D   L O G I S T I C
function* loadLogisticSaga() {
    try {
        const logistic = yield select(getLogistic);
        const { offset, limit, filters, sort } = logistic;
        const params = {
            offset,
            limit,
        };

        if (sort !== null) {
            const sortInt = sort.type === 'asc' ? 1 : -1;

            if (sort.key === 'created_at') {
                params.sort_by = JSON.stringify({ created_at: sortInt });
            }
        }

        const filterParams = { order_status: { ne: 'CANCELED' } };

        if (filters.source !== undefined) {
            filterParams.source = filters.source;
        }

        if (filters.shippingMethod.length > 0) {
            filterParams.shipping_type_id = filters.shippingMethod;
        }

        if (filters.customer.length > 0) {
            filterParams.customer_id = filters.customer;
        }

        if (filters.order_item_number !== '') {
            filterParams.item_order_number = filters.order_item_number.trim();
        }

        if (filters.order_number !== '') {
            filterParams.order_number = filters.order_number.trim();
        }

        if (filters.consignment_number !== '') {
            filterParams['logistics.labels.consignment_number'] = filters.consignment_number.trim();
        }

        if (filters.productGroup.length > 0) {
            filterParams.product_group_id = filters.productGroup;
        }

        if (filters.specifications.length > 0) {
            filterParams['configurations.configuration_id'] = filters.specifications;
        }

        if (filters.quantity !== '') {
            filterParams.quantity = parseInt(filters.quantity.trim(), 10);
        }

        if (filters.expected_shipping_date !== undefined) {
            filterParams.expected_shipping_date = `${filters.expected_shipping_date} 00:00:00`;
        }

        if (filters.state !== undefined) {
            filterParams.state = filters.state;
        }

        params.filter = JSON.stringify(filterParams);

        const result = yield LogisticApis.getLogisticApi(params);

        if (result.status === 200) {
            const logisticResult = result.data;

            let configurationsIDS = [];
            let productGroupIDS = [];
            let shippingTypeIDS = [];
            let userIDS = [];
            let addressIDS = [];
            let customerIDS = [];

            result.data.hits.forEach((hit) => {
                hit.configurations.forEach((config) => {
                    configurationsIDS.push(config.configuration_id);
                });
                productGroupIDS.push(hit.product_group_id);

                shippingTypeIDS.push(hit.shipping_type_id);

                const [shippingDetails] = hit.shipping_details;
                addressIDS.push(shippingDetails?.address_id);

                customerIDS.push(hit.customer_id);

                hit.states.forEach(state => userIDS.push(state.updated_by));

                (hit.comments || []).forEach((comment) => {
                    if (comment.created_by) {
                        userIDS.push(comment.created_by);
                    }

                    if (comment.receivers) {
                        userIDS.push(...comment.receivers);
                    }
                });
            });

            productGroupIDS = uniq(productGroupIDS);
            configurationsIDS = uniq(configurationsIDS);
            shippingTypeIDS = uniq(shippingTypeIDS);
            userIDS = uniq(userIDS);
            addressIDS = uniq(addressIDS);
            customerIDS = uniq(customerIDS);

            yield put(LogisticActions.loadLogisticRes(logisticResult));

            const macroProductGroups = yield Macros.getProductGroupsMacro(productGroupIDS);
            const macroConfigurations = yield Macros.getConfigurationsMacro(configurationsIDS);
            const macroShippingTypes = yield Macros.getShippingTypeMacro(shippingTypeIDS);
            const macroUsers = yield Macros.getUsersMacro(userIDS);
            const macroAddresses = yield Macros.getAddressesMacro(addressIDS);
            const macroCustomers = yield Macros.getCustomersMacro(customerIDS);

            const users = macroUsers.data.hits || [];
            const configurations = macroConfigurations?.data?.hits || [];
            const productGroups = macroProductGroups?.data?.hits || [];
            const shippings = macroShippingTypes?.data?.hits || [];
            const addresses = macroAddresses?.data?.hits || [];
            const customers = macroCustomers?.data?.hits || [];

            yield put(LogisticActions.setLogisticNeededData({
                users,
                configurations,
                productGroups,
                shippings,
                addresses,
                customers,
            }));
        } else {
            yield put(LogisticActions.loadLogisticErr());
        }
    } catch (e) {
        yield put(LogisticActions.loadLogisticErr());
        console.log(e);
    }
}

export function* loadLogisticWatcher() {
    yield takeLatest(LogisticTypes.LOAD_LOGISTIC, loadLogisticSaga);
}
// L O A D   L O G I S T I C

// S E T   L O G I S T I C   C O M M E N T
function* setLogisticCommentSaga(action) {
    try {
        const layout = yield select(getLayout);
        const { locale } = layout;
        const result = yield LogisticApis.commentLogisticApi(action.data);

        if (result.status === 202) {
            yield put(LogisticActions.setLogisticCommentRes(true, false));
            yield put(LogisticActions.setLogisticCommentRes(false, true));
            yield delay(1000);
            yield put(LogisticActions.setLogisticCommentRes(false, false));
            setNotification('success', locale, 'global.success', 'logistics.notification.commentItemSuccess');
            yield call(loadLogisticSaga);
        } else {
            setNotification('error', locale, 'global.error', 'logistics.notification.commentItemError');
            yield put(LogisticActions.setLogisticCommentErr());
        }
    } catch (e) {
        console.log(e);
        yield put(LogisticActions.setLogisticCommentErr());
    }
}

export function* setLogisticCommentWatcher() {
    yield takeLatest(LogisticTypes.SET_LOGISTIC_COMMENT, setLogisticCommentSaga);
}
// S E T   L O G I S T I C   C O M M E N T

// P R I N T   L A B E L   P D F
function* printLabelPDF(linkToPDF) {
    const defaultPrinter = yield qz.printers.getDefault();
    const config = qz.configs.create(defaultPrinter);
    const data = [{
        type: 'pixel',
        format: 'pdf',
        flavor: 'file',
        data: linkToPDF,
    }];
    yield qz.print(config, data);
}

// P R I N T   L A B E L   P D F

// S T O P   L O G I S T I C   I T E M
function* simplePrintLabelSaga({ data }) {
    const { locale } = yield select(getLayout);

    try {
        const resultJob = yield LogisticApis.createLogisticJobApi(data.job);

        if (resultJob.status === 202) {
            // check shipping type
            let resultLabel = null;

            if (data.pick) {
                resultLabel = yield LogisticApis.generatePackingNoteApi(data.pick);
            } else {
                resultLabel = yield LogisticApis.createLabelApi(data.label);
            }

            yield put(LogisticActions.setCheckedLogistic([]));
            yield put(LogisticActions.setPrintLabelPopup(false));

            if (resultLabel.status === 202) {
                try {
                    yield put(LogisticActions.simplePrintLabelRes());
                    setNotification('success', locale, 'global.success', 'logistics.notification.stopItemSuccess');

                    yield delay(2000);

                    let changedLogistic = null;

                    for (let i = 0; i < 5; i += 1) {
                        yield call(loadLogisticSaga);

                        const { listing } = yield select(getLogistic);
                        changedLogistic = listing.hits.find(hit => hit._id === data.job.job_id);

                        if (changedLogistic && changedLogistic.logistics.labels.length !== 0) {
                            const boxs = data.job.box_quantity;
                            let { labels } = changedLogistic.logistics;

                            if (boxs) {
                                labels = takeRight(labels, boxs);
                            }

                            for (let j = 0; j < labels.length; j += 1) {
                                yield call(printLabelPDF, labels[j].pdf_file);
                            }

                            break;
                        }

                        yield delay(2000);
                    }
                } catch (e) {
                    if (e.message === '_qz.websocket.connection is null') {
                        setNotification('error', locale, 'global.error', 'logistics.qzTray.error');
                    } else {
                        console.log(e);
                    }
                }
            } else {
                const errorJob = yield resultJob.json();
                const errorLabel = yield resultLabel.json();

                if (errorJob.message) {
                    setNotification('error', locale, 'global.error', errorJob.message, { noTranslateMsg: true });
                }

                if (errorLabel.message) {
                    setNotification('error', locale, 'global.error', errorLabel.message, { noTranslateMsg: true });
                }

                yield put(LogisticActions.simplePrintLabelErr());
            }
        }
    } catch (e) {
        yield put(LogisticActions.setPrintLabelPopup(false));
        yield put(LogisticActions.setCheckedLogistic([]));
        yield put(LogisticActions.simplePrintLabelErr());
        console.log(e);
    }
}

export function* simplePrintLabelWatcher() {
    yield takeLatest(LogisticTypes.SIMPLE_PRINT_LABEL, simplePrintLabelSaga);
}
// S T O P   L O G I S T I C   I T E M

// B U L K   S T O P   L O G I S T I C   I T E M
function* printGroupedLabelSaga({ data }) {
    const layout = yield select(getLayout);
    const { locale } = layout;

    try {
        const resultJob = yield LogisticApis.createLogisticJobApi(data.job);

        if (resultJob.status === 202) {
            yield delay(1000);

            let resultLabel = null;

            if (data.pick) {
                resultLabel = yield LogisticApis.generatePackingNoteApi(data.pick);
            } else {
                resultLabel = yield LogisticApis.createLabelApi(data.label);
            }

            yield put(LogisticActions.setCheckedLogistic([]));
            yield put(LogisticActions.setPrintLabelPopup(false));

            const allLogisticIds = [data.job.job_id];

            if (resultLabel.status === 202) {
                try {
                    setNotification('success', locale, 'global.success', 'logistics.notification.bulkStopItemSuccess');
                    yield delay(2000);
                    let changedLogistic = null;
                    let logistic = null;

                    yield put(LogisticActions.printGroupedLabelRes());

                    yield call(loadLogisticSaga);
                    logistic = yield select(getLogistic);
                    const { listing } = logistic;

                    for (let i = 0; i < allLogisticIds.length; i += 1) {
                        const id = allLogisticIds[i];
                        changedLogistic = listing.hits.find(hit => hit._id === id);

                        if (changedLogistic?.logistics.labels) {
                            for (let j = 0; j < changedLogistic.logistics.labels.length; j += 1) {
                                const label = changedLogistic.logistics.labels[j];
                                yield call(printLabelPDF, label.pdf_file);
                                yield delay(20);
                            }
                        }
                    }
                } catch (e) {
                    if (e.message === '_qz.websocket.connection is null') {
                        setNotification('error', locale, 'global.error', 'logistics.qzTray.error');
                    } else {
                        console.log(e);
                    }
                }
            } else {
                const errorJob = yield resultJob.json();
                const errorLabel = yield resultLabel.json();

                if (errorJob.message) {
                    setNotification('error', locale, 'global.error', errorJob.message, { noTranslateMsg: true });
                }

                if (errorLabel.message) {
                    setNotification('error', locale, 'global.error', errorLabel.message, { noTranslateMsg: true });
                }

                yield put(LogisticActions.printGroupedLabelErr());
            }
        } else {
            const errorJob = yield resultJob.json();

            if (errorJob.message) {
                setNotification('error', locale, 'global.error', errorJob.message, { noTranslateMsg: true });
            }

            yield put(LogisticActions.printGroupedLabelErr());
        }
    } catch (e) {
        yield put(LogisticActions.setPrintLabelPopup(false));
        yield put(LogisticActions.setCheckedLogistic([]));
        yield put(LogisticActions.printGroupedLabelErr());
        console.log(e);
    }
}

export function* printGroupedLabelWatcher() {
    yield takeLatest(LogisticTypes.PRINT_GROUPED_LABEL, printGroupedLabelSaga);
}
// B U L K   S T O P   L O G I S T I C   I T E M


// T N T   D O C U M E N T S
function* loadTNTDocumentsSaga() {
    try {
        const logistic = yield select(getLogistic);
        const { offset, limit, filters, sort } = logistic.convocationTNT.listing;
        const params = {
            offset,
            limit,
        };

        if (sort !== null) {
            const sortInt = sort.type === 'asc' ? 1 : -1;

            if (sort.key === 'created_at') {
                params.sort_by = JSON.stringify({ created_at: sortInt });
            }
        }

        const filterParams = {};

        if (filters.submit_date.length > 0) {
            filterParams.submit_date = {
                between: filters.submit_date.map(date => moment(date).format('YYYY-MM-DD HH:mm:ss')),
            };
        }

        if (filters.collection_date.length > 0) {
            filterParams.collection_date = {
                between: filters.collection_date.map(date => moment(date).format('YYYY-MM-DD HH:mm:ss')),
            };
        }

        params.filter = JSON.stringify(filterParams);

        const result = yield LogisticApis.getTNTDocumentsApi(params);

        if (result.status === 200) {
            yield put(LogisticActions.loadTNTDocumentsRes(result.data));
        } else {
            yield put(LogisticActions.loadTNTDocumentsErr());
        }
    } catch (e) {
        yield put(LogisticActions.loadTNTDocumentsErr());
        console.log(e);
    }
}

export function* loadTNTDocumentsWatcher() {
    yield takeLatest(LogisticTypes.LOAD_TNT_DOCUMENTS, loadTNTDocumentsSaga);
}
// T N T   D O C U M E N T S

// T N T   L A B E L
function* loadTNTLabelsSaga(data) {
    try {
        const params = { filter: JSON.stringify(data) };
        const result = yield LogisticApis.getTNTLabelApi(params);

        if (result.status === 200) {
            yield put(LogisticActions.loadTNTLabelRes(result.data));
        } else {
            yield put(LogisticActions.loadTNTLabelErr());
        }
    } catch (e) {
        yield put(LogisticActions.loadTNTLabelErr());
        console.log(e);
    }
}

export function* loadTNTLabelsWatcher() {
    yield takeLatest(LogisticTypes.LOAD_TNT_LABEL, loadTNTLabelsSaga);
}
// T N T  L A B E L

// S E N D   D E M A N D   C O N V O C A T I O N   T N T
function* sendDemandConvocationTNTSaga({ data }) {
    const { locale } = yield select(getLayout);
    const form = yield select(getForm);
    const { values } = form.generateShipmentsForm;

    try {
        const collectionDate = moment(values.collection_date);
        const alternativeCollectionDate = moment(values.alternative_collection_date);

        const params = {
            start_date: moment(values.start_date).format('YYYY-MM-DD HH:mm:00'),
            end_date: moment(values.end_date).format('YYYY-MM-DD HH:mm:00'),
            collection_from: collectionDate.format('YYYY-MM-DD HH:mm:00'),
            collection_to: collectionDate.add(1, 'hours').format('YYYY-MM-DD HH:mm:00'),
            alternative_collection_from: `${collectionDate.format('YYYY-MM-DD')} ${alternativeCollectionDate.format('HH:mm')}:00`,
            alternative_collection_to: `${collectionDate.format('YYYY-MM-DD')} ${alternativeCollectionDate.add(1, 'hours').format('HH:mm')}:00`,
            activity: data.activity,
        };

        const bools = [true, false];

        const errorStatus = [];

        for (let i = 0; i < bools.length; i += 1) {
            const bool = bools[i];
            const result = yield LogisticApis.sendDemandConvocationTNTApi({ ...params, is_neutral: bool });

            if ([200, 202].includes(result.status)) {
                setNotification('success', locale, bool ? 'logistics.convocationTNT.success.withNeutral' : 'global.success', `logistics.convocationTNT.notification.submit.success.${bool ? 'neutral' : 'normalShipping'}`);
                yield delay(200);
            } else {
                const json = yield result.json();
                errorStatus.push({ status: result.status, json, isNeutral: bool });
                yield delay(200);
            }
        }

        if (errorStatus.length > 0) {
            errorStatus.forEach((error) => {
                if (error.status === 400) {
                    setNotification('warn', locale, error.isNeutral ? 'logistics.convocationTNT.warning.withNeutral' : 'logistics.convocationTNT.warning.normalShipping', `No labels have been created. ${error.json.message}`, { noTranslateMsg: true });
                } else {
                    setNotification('error', locale, error.isNeutral ? 'logistics.convocationTNT.error.withNeutral' : 'global.error', error.json.message, { noTranslateMsg: true });
                }
            });
            yield put(LogisticActions.sendDemandConvocationTNTErr());
        } else {
            yield put(LogisticActions.sendDemandConvocationTNTRes());
        }

        yield put(LogisticActions.resetTNTDocumentsFilters());
        yield put(LogisticActions.loadTNTDocuments());
        yield call(loadTNTLabelsSaga, { 'logistics.labels.created_at': { between: [params.start_date, params.end_date] }, logistics_status: ['CREATE_IN_SHIPMENT_SERVICE', 'SHIPPING_ERROR'] });
    } catch (e) {
        setNotification('error', locale, 'global.error', 'logistics.convocationTNT.notification.submit.error');
        yield put(LogisticActions.sendDemandConvocationTNTErr());
        console.log(e);
    }
}

export function* sendDemandConvocationTNTWatcher() {
    yield takeLatest(LogisticTypes.SEND_DEMAND_CONVOCATION_TNT, sendDemandConvocationTNTSaga);
}
// S E N D   D E M A N D   C O N V O C A T I O N   T N T

// D E L E T E   L O G I S T I C   L A B E L
function* deleteLogisticLabelSaga(action) {
    const { locale } = yield select(getLayout);

    try {
        const result = yield LogisticApis.deleteLogisticLabelApi(action.data);

        if (result.status === 202) {
            yield put(LogisticActions.deleteLogisticLabelRes());
            setNotification('success', locale, 'global.success', 'logistics.deleteLabel.notification.success');

            if (action.data.convocation) {
                yield put(LogisticActions.loadTNTLabel());
            } else {
                yield call(loadLogisticSaga, {});
            }
        } else {
            const error = yield result.json();
            setNotification('error', locale, 'global.error', error.message, { noTranslateMsg: true });
            yield put(LogisticActions.deleteLogisticLabelErr());
        }
    } catch (e) {
        yield put(LogisticActions.deleteLogisticLabelErr());
        setNotification('error', locale, 'global.error', 'logistics.deleteLabel.notification.error');
        console.log(e);
    }
}

export function* deleteLogisticLabelWatcher() {
    yield takeLatest(LogisticTypes.DELETE_LOGISTIC_LABEL, deleteLogisticLabelSaga);
}
// D E L E T E   L O G I S T I C   L A B E L
